import React, { Component } from 'react';
import './ColorTool.css';
import { SchemeContainer } from '../components/Scheme.jsx';

//SVG and PNG imports
//import { ReactComponent as MainBack } from '../img/CT_Main.svg';
import { ReactComponent as BagBack } from '../img/CT_Bag_Back.svg';
import { ReactComponent as CapLight } from '../img/CT_light.svg';
import { ReactComponent as ShoesDark } from '../img/CT_dark.svg';
import MainPNG from '../img/CT_Main.png';
import BagPNG from '../img/CT_Bag.png';
import SubColorPNG from '../img/CT_sub_color.png';

//import the Color Package to map Color Keys 
import ColorPackage from './colorData.js';

//States for Interacting with the Tool
export let pickerState = 0; //0 = Bag/Background | 1 = Bag | 2 = Background  



export class ColorTool extends Component {

    changeScheme(e, id) {
        //### Variables
        const primaryScheme = document.getElementById("Primary");
        const secondaryScheme = document.getElementById("Secondary");
        //###
        console.clear();
        if (e !== pickerState) {
            primaryScheme.classList.remove("selected");
            secondaryScheme.classList.remove("selected");
            pickerState = e;
            //console.log("new State set to:" + pickerState);
            document.getElementById(id).classList.add("selected");
        } else {
            pickerState = 0;
            //console.log("State has been reset to:" + pickerState);
            primaryScheme.classList.remove("selected");
            secondaryScheme.classList.remove("selected");
        }
    }

    changeColor(i) {
        //### Variables
        const primaryHex = document.getElementById("P-hex");
        const primaryColor = document.getElementById("P-color");
        const primaryFontColor = document.getElementById("P-font-color");
        const primaryLightColor = document.getElementById("P-light-color");
        const primaryLightHex = document.getElementById("P-light-hex");
        const primaryDarkColor = document.getElementById("P-dark-color");
        const primaryDarkHex = document.getElementById("P-dark-hex");
        const primaryDarkSVG = document.getElementById("preview-svg-dark")
        const primaryLightSVG = document.getElementById("preview-svg-light")
        //
        const secondaryHex = document.getElementById("S-hex");
        const secondaryColor = document.getElementById("S-color");
        const secondaryFontColor = document.getElementById("S-font-color");
        const secondaryLightColor = document.getElementById("S-light-color");
        const secondaryLightHex = document.getElementById("S-light-hex");
        const secondaryDarkColor = document.getElementById("S-dark-color");
        const secondaryDarkHex = document.getElementById("S-dark-hex");
        //
        const primaryImage = document.getElementById("preview-svg-bag");
        const secondaryBackground = document.getElementById("ColorTool");
        //###
        //### TinyColor
        var tinycolor = require("tinycolor2");
        var mainColor = tinycolor(i);
        var lightColor = tinycolor(i);
        lightColor.lighten(15);
        var darkColor = tinycolor(i);
        darkColor.darken(15);
        //###

        if (1 === pickerState) {
            // Bag Primary
            primaryImage.style.fill = i;
            // Scheme main
            primaryColor.style.backgroundColor = i;
            primaryColor.style.borderWidth = 0;
            primaryHex.innerHTML = i;
            if (mainColor.isDark() === true) {
                primaryColor.style.color = "white ";
            } else {
                primaryColor.style.color = "black";
            };
            // Scheme Light
            primaryLightColor.style.background = lightColor;
            primaryLightSVG.style.fill = lightColor;
            primaryLightColor.style.borderWidth = 0;
            primaryLightHex.innerHTML = lightColor.toHexString();
            if (lightColor.isDark() === true) {
                primaryLightColor.style.color = "white ";
            } else {
                primaryLightColor.style.color = "black";
            };
            // Scheme Dark
            primaryDarkColor.style.background = darkColor;
            primaryDarkSVG.style.fill = darkColor;
            primaryDarkColor.style.borderWidth = 0;
            primaryDarkHex.innerHTML = darkColor.toHexString();
            if (darkColor.isDark() === true) {
                primaryDarkColor.style.color = "white ";
            } else {
                primaryDarkColor.style.color = "black";
            };

        } else if (2 === pickerState) {
            // Background Secondary
            secondaryBackground.style.backgroundColor = i;
            // Scheme main
            secondaryColor.style.backgroundColor = i;
            secondaryColor.style.borderWidth = 0;
            secondaryHex.innerHTML = i;
            if (mainColor.isDark() === true) {
                secondaryColor.style.color = "white";
            } else {
                secondaryColor.style.color = "black";
            };
            // Scheme Light
            secondaryLightColor.style.background = lightColor;
            secondaryLightColor.style.borderWidth = 0;
            secondaryLightHex.innerHTML = lightColor.toHexString();
            if (lightColor.isDark() === true) {
                secondaryLightColor.style.color = "white";
            } else {
                secondaryLightColor.style.color = "black";
            };
            // Scheme Dark
            secondaryDarkColor.style.background = darkColor;
            secondaryDarkColor.style.borderWidth = 0;
            secondaryDarkHex.innerHTML = darkColor.toHexString();
            if (darkColor.isDark() === true) {
                secondaryDarkColor.style.color = "white";
            } else {
                secondaryDarkColor.style.color = "black";
            };

        } else if (0 === pickerState) {
            // both Prime-Sec
            primaryImage.style.fill = i;
            secondaryBackground.style.backgroundColor = i;
            // ### Prime
            // Scheme main
            primaryColor.style.backgroundColor = i;
            primaryColor.style.borderWidth = 0;
            primaryHex.innerHTML = i;
            if (mainColor.isDark() === true) {
                primaryColor.style.color = "white";
            } else {
                primaryColor.style.color = "black";
            };
            // Scheme Light
            primaryLightColor.style.background = lightColor;
            primaryLightSVG.style.fill = lightColor;
            primaryLightColor.style.borderWidth = 0;
            primaryLightHex.innerHTML = lightColor.toHexString();
            if (lightColor.isDark() === true) {
                primaryLightColor.style.color = "white";
            } else {
                primaryLightColor.style.color = "black";
            };
            // Scheme Dark
            primaryDarkColor.style.background = darkColor;
            primaryDarkSVG.style.fill = darkColor;
            primaryDarkColor.style.borderWidth = 0;
            primaryDarkHex.innerHTML = darkColor.toHexString();
            if (darkColor.isDark() === true) {
                primaryDarkColor.style.color = "white";
            } else {
                primaryDarkColor.style.color = "black";
            };
            // ### Second
            // Scheme main
            secondaryColor.style.backgroundColor = i;
            secondaryColor.style.borderWidth = 0;
            secondaryHex.innerHTML = i;
            if (mainColor.isDark() === true) {
                secondaryColor.style.color = "white";
            } else {
                secondaryColor.style.color = "black";
            };
            // Scheme Light
            secondaryLightColor.style.background = lightColor;
            secondaryLightColor.style.borderWidth = 0;
            secondaryLightHex.innerHTML = lightColor.toHexString();
            if (lightColor.isDark() === true) {
                secondaryLightColor.style.color = "white";
            } else {
                secondaryLightColor.style.color = "black";
            };
            // Scheme Dark
            secondaryDarkColor.style.background = darkColor;
            secondaryDarkColor.style.borderWidth = 0;
            secondaryDarkHex.innerHTML = darkColor.toHexString();
            if (darkColor.isDark() === true) {
                secondaryDarkColor.style.color = "white";
            } else {
                secondaryDarkColor.style.color = "black";
            };

        } else {
            console.log("Error encountered! Please reload page!")
        }
    }

    render() {
        return (
            <div id="ColorTool">
                {/* Image Space */}
                <div className="ColorTool-Container">                     
                    <div className="Canvas-Container" >
                        {/*preview-main*/}
                        <img id="preview-main-png" className="Layer" src={MainPNG} alt=""></img>
                        {/*priview-sub-colors*/}
                        <ShoesDark id="preview-svg-dark" className="Layer" style={{ fill: "#fff" }} />
                        <CapLight id="preview-svg-light" className="Layer" style={{ fill: "#fff" }} />
                        <img id="preview-png-sub-color" className="Layer" src={SubColorPNG} alt=""></img>
                        {/*preview-colors*/}
                        <BagBack id="preview-svg-bag" className="Layer" style={{ fill: "#fff" }} />
                        <img id="preview-png-bag" className="Layer" src={BagPNG} alt=""></img>
                    </div>
                    
                    {/* */}
                    <div className="Color-Tabs-Controller"> 
                        {/* Color Selector */}
                        <div className="Grid Scroll">
                            {ColorPackage.map(({ color, idKey }) => {
                                return <div
                                    className="Tab"
                                    key={idKey}
                                    id={idKey}
                                    onClick={() => this.changeColor(color)}
                                    style={{ backgroundColor: color }}
                                ></div>
                            })}
                        </div>

                        <div id="Scheme-Controller">
                            {/* Primary and Secondary Buttons */}
                            <SchemeContainer ordinal="Primary" ordinal_s="P" function={() => this.changeScheme(1, "Primary")} />
                            <SchemeContainer ordinal="Secondary" ordinal_s="S" function={() => this.changeScheme(2, "Secondary")} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


